import getBase from '@/api/base'

const {get} = getBase(true)

export const dealList = () => get('/deal')

export const dealCarouselList = () => get('/deal/carousel')
